import React from 'react';
import { Card, CardContent, Typography, Box, List, ListItem } from '@mui/material';
import './RedFlags.css';

const RedFlags = ({ redFlags }) => {
  const flags = redFlags && Array.isArray(redFlags) ? redFlags : [];

  const splitTextIntoLines = (text, maxWordsPerLine) => {
    return text
      .split(' ')
      .reduce((acc, word, index, arr) => {
        if (index % maxWordsPerLine === 0 && index !== 0) {
          acc.push(arr.slice(index - maxWordsPerLine, index).join(' '));
        }
        if (index === arr.length - 1) {
          acc.push(arr.slice(index - (index % maxWordsPerLine), index + 1).join(' '));
        }
        return acc;
      }, [])
      .map((line, lineIndex) => (
        <React.Fragment key={lineIndex}>
          {line}
          <br />
        </React.Fragment>
      ));
  };

  return (
    <Card className="redFlags-card"
      sx={{ borderRadius: "12px", boxShadow: "none", border: "none" }}
    >
      <CardContent className="redFlags-card-content">
        <Typography className="redFlags-title">
          Red Flags
        </Typography>
      </CardContent>
      <CardContent className="redFlags-list-content">
        <List>
          {flags.length > 0 ? (
            flags.map((item, index) => (
              <ListItem key={index} className="redFlags-list-item">
                <Box className="redFlags-box">
                  <Box className="redFlags-issue-timestamp">
                    <Typography component="div" className="redFlags-text">
                      {item.issue
                        .replace(/\band\b/g, '&')
                        .split(' ')
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(' ')}
                    </Typography>
                    <Box className="redFlags-timestamp">
                      <Typography className="redFlags-timestamp-text">
                        {item.timestamp && item.timestamp !== 'Multiple throughout' 
                          ? `Timestamp: ${item.timestamp}` 
                          : 'No valid timestamp'}
                      </Typography>
                    </Box>
                  </Box>
                  <Typography component="div" className="redFlags-context">
                    {splitTextIntoLines(item.context)} 
                  </Typography>
                </Box>
              </ListItem>
            ))
          ) : (
            <Typography className="no-red-flags">
              No red flags detected
            </Typography>
          )}
        </List>
      </CardContent>
    </Card>
  );
};

export default RedFlags;